<template>
    <div class="bento-section">
        <section class="bento-card" ref="intelSection" :class="{ 'is-visible': intelVisible }">
            <div class="bento-content">
                <h1 class="bento-title fuente-posm">Intel</h1>
                <div class="bento-row">
                    <p class="bento-subtitle fuente-posm">
                        Facturación desde tu ticket + automatizaciones SAT
                    </p>
                    <router-link to="/intel" custom v-slot="{ navigate }">
                        <button @click="navigate" class="bento-button fuente-nova2">
                            DESCUBRE COMO
                        </button>
                    </router-link>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'page5',
    data() {
        return {
            intelVisible: false,
            observer: null
        }
    },
    mounted() {
        const section = this.$refs.intelSection
        if (!section) return

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.intelVisible = true
                        this.observer.disconnect()
                    }
                })
            },
            { threshold: 0.25 }
        )
        this.observer.observe(section)
    },
    beforeUnmount() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }
}
</script>

<style lang="css" scoped>
.bento-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
    scroll-snap-align: start;
}

.bento-card {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
        url('~@/assets/images/a78.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 700px;
    color: white;
    border-top-left-radius: 65px;
    border-top-right-radius: 65px;
    transform: translateY(60px);
    opacity: 0;
    transition:
        transform 0.9s cubic-bezier(0.19, 1, 0.22, 1),
        opacity 0.9s ease-out;
}

.bento-card.is-visible {
    transform: translateY(0);
    opacity: 1;
}

.bento-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 60px;
}

.bento-title {
    font-size: clamp(55px, 5vw, 88px);
    font-weight: 700;
    margin: 0 0 20px 0;
    line-height: 1;
    color: white;
}

.bento-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 10px;
}

.bento-subtitle {
    font-size: clamp(20px, 3vw, 45px);
    font-weight: 400;
    line-height: 1.2;
    margin: 0;
    margin-left: 40px;
    color: white;
}

.bento-button {
    background-color: transparent;
    color: white;
    border: 2px solid white;
    border-radius: 8px;
    padding: 14px 35px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    margin-right: 30px;
}

.bento-button:hover {
    background-color: white;
    color: #040404;
}

/* Tablet */
@media (max-width: 1201px) {
    .bento-card {
        height: 500px;
    }
}

@media (max-width: 992px) {
    .bento-content {
        padding: 0 40px;
    }

    .bento-title {
        font-size: 56px;
    }

    .bento-subtitle {
        font-size: 18px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .bento-section {
        padding: 80px 20px;
        align-items: center;
        justify-content: center;
    }

    .bento-card {
        height: calc(100vh - 160px);
        border-radius: 20px;
        transform: translateY(0);
        opacity: 1;
        background-position: center 30%;
    }

    .bento-content {
        padding: 30px;
        align-items: center;
        text-align: center;
    }

    .bento-title {
        font-size: 48px;
        margin-bottom: 30px;
    }

    .bento-row {
        flex-direction: column;
        gap: 30px;
    }

    .bento-subtitle {
        font-size: 18px;
        margin-left: 0;
    }

    .bento-button {
        margin-right: 0;
        padding: 16px 40px;
    }
}
</style>
